<template>
    <Button href="#" @click="visible = true" class="p-button p-component p-button-success text-lg text-white" v-if="show_button">
        Separa
    </Button>

    <Dialog v-model:visible="visible" modal :header="title" :style="{ width: '66%' }" pt:root:class="separa-ticket-modal" ref="dialog">

        <div class=" flex flex-col gap-4 mb-4">

            <div>
                <h2 class="text-lg ">{{ $root.trans.ticket_principale }} </h2>
                <p> <b>{{ main_ticket.numero_progressivo }}</b> {{ main_ticket.titolo }}</p>
            </div>
            <h2  class="text-lg">{{ $root.trans.ticket_uniti }}</h2> 
            <div class="uniti">
                <div v-for="t in ticket_uniti" :key="t.id" class="flex justify-between">
                    <div>
                        <p><b>{{ t.numero_progressivo }}</b> {{ t.titolo }}</p>
                    </div>
                    <Button type="button" label="Separa questo ticket" @click="separa(t.id)"></Button>
                </div>
            </div>
        </div>
        <div class="flex justify-center gap-2 actions">
            <Button type="button" :label="$root.trans.annulla" severity="secondary" @click="visible = false"></Button>
            <Button type="button" @click="separa()"><img src="/img-appalto/unmergeicon.svg"/> {{ $root.trans.separa_tutti }}</Button>
        </div>
    </Dialog>
</template>

  <script>

  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import InputText from 'primevue/inputtext';
  import DatePicker from 'primevue/datepicker';
  import FormInput from './FormInput.vue';




  export default {
    name: "SeparaTicketModal",
    components: {
        InputText,
		Dialog,
        DatePicker,
		Button,
        FormInput
	},
    props: ['action','main_ticket','ticket_uniti', 'title','show_button'],
    data() {
      return {
        visible: false,
        id: this.id,
        azione: this.action,
        errors: {},
        imginput: false,
        idform: this.id,
      };
    },
    created(){

    },
    mounted() {
        console.log(this.cancelText);
        console.log(this.main_ticket);
        console.log(this.ticket_uniti);
    },
    methods: {
        separa(id = null){
            const params = {
                id: this.main_ticket.id,
            }
            if(id){
                params.id_figlio = id
            }

            const url = route('ticketing/separa_ticket', params);
            axios.get(url).then(response => {
                console.log(response)
                this.visible = false;
                location.reload();
            }).catch(error => {
                console.log(error);
                console.error("Errore durante la separazione del ticket:", error);
                this.$toast.add({severity:'error', summary: 'Errore', detail: 'Impossibile separare il ticket.', life: 3000});
            });
        }
    }
  }
  </script>

  <style scoped>

  </style>
